module.exports = __webpack_public_path__ + "static/media/archway.9401ce68.svg";